module.exports = __webpack_public_path__ + "static/media/0052.b1964e6d.jpg";